import { ResponseMessage } from '../types';
async function fetchChatResponse(
  url: string,
  sessionId: string,
  data: string,
  chatCount: number,
  uniqueId: string
): Promise<ResponseMessage> {
  try {
    const body = uniqueId === '' ? [
      {
        sessionId: sessionId,
        action: 'sendMessage',
        chatInput: data,
        chatCount: chatCount,
      }
    ] :
      {
        sessionId: sessionId,
        action: 'sendMessage',
        chatInput: data,
        chatCount: chatCount,
        uniqueId: uniqueId
      };
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (response.ok) {
      const text = await response.text();

      //Trim the spaces leading and trailing
      if (!text.trim())
        return {
          content: `No Data`,
        };

      //parse the recieved JSON to the required format
      try {
        const result = JSON.parse(text);
        const key = Object.keys(result)[0];
        return {
          content: result['output'],
        };
      } catch (err) {
        console.error('Invalid JSON:', text);
      }
    }

    return {
      content: "Couldn't fetch data",
    };
  } catch (err) {
    return {
      content: "Couldn't fetch data",
    };
  }
}

export { fetchChatResponse };

